import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { DepotSchemaConfig } from './domain/depot-schema-config';
import {
	openCreateDepotEntityModal,
	openDepotHeaderFieldsSelection,
} from './store';

@Injectable()
export class NgDepot {
	public constructor(private readonly store: Store) {}

	public openHeaderFieldsSelection(
		params: DepotSchemaConfig,
		currentSchema: unknown | null
	): void {
		this.store.dispatch(
			openDepotHeaderFieldsSelection({
				currentSchema,
				params,
			})
		);
	}

	public openCreateEntityFromDepotModal(
		depotId: number,
		depotLabel: string,
		depotType: string
	): void {
		this.store.dispatch(
			openCreateDepotEntityModal({
				depotId,
				depotLabel,
				depotType,
			})
		);
	}
}
